document.addEventListener("DOMContentLoaded", () => {
    const codeNotFormatted = document.querySelectorAll("pre:not(.formatted)");

    codeNotFormatted.forEach((c, index) => {
        const container = document.createElement("div");
        container.wrapAll(c);

        if (container.querySelector("code")) {
            container.classList.add("snippet-container");
            const targetId = `after-code-${index + 1}`;

            const copyButton = document.createElement("a");
            copyButton.className = "copy-to-clipboard-button-not-formatted btn btn-copy-not-formatted";
            copyButton.textContent = "Copy";

            const skipLink = document.createElement("a");
            skipLink.href = `#${targetId}`;
            skipLink.className = "skip-content sr-only sr-only-focusable";
            skipLink.textContent = "Skip code example";

            container.prepend(copyButton);
            container.prepend(skipLink);

            const copyContent = document.createElement("div");
            copyContent.className = "copy-content";
            copyContent.style.display = "none";
            container.append(copyContent);

            container.querySelector("code").classList.add("code-snippet");

            const targetSpan = document.createElement("span");
            targetSpan.id = targetId;
            targetSpan.tabIndex = -1;
            container.append(targetSpan);

            const copyDiv = container.querySelector(".copy-content");
            const btn = container.querySelector(".copy-to-clipboard-button-not-formatted");

            const codeEl = container.querySelector("code").cloneNode(true);

            codeEl.querySelectorAll("br").forEach((br) => {
                br.replaceWith(document.createTextNode("\r\n"));
            });

            copyDiv.value = unescapeHTML(codeEl.textContent);

            btn.addEventListener("click", function () {
                window.direct.selectText(container.querySelector(".code-snippet"));
                navigator.clipboard.writeText(copyDiv.value).then(() => {
                    btn.setAttribute("data-copy-state", "copy-success");
                    setTimeout(() => {
                        btn.removeAttribute("data-copy-state");
                    }, 2000);
                });
            });
        }
    });

    const allCodeSnippetContainers = document.querySelectorAll(".all-code-language-container");
    const codeComponents = {};

    allCodeSnippetContainers.forEach((container, idx) => {
        codeComponents[`vm-snippet-${idx}`] = new window.Vue({
            name: `code snippet-${container.id}`,
            el: `#${container.id}`,
            data() {
                return {
                    snippetUrl: "",
                    selectedLanguage: {},
                    canLinkToAPIExplorer: false,
                    loading: false,
                    languageOptions: {
                        backend: [
                            { name: "Java", value: "JAVA", paramExplorer: "JAVA" },
                            { name: ".NET", value: "DOTNET", paramExplorer: "DOTNET" },
                            { name: "Node.js", value: "JS", paramExplorer: "JS" },
                            { name: "PHP", value: "PHP", paramExplorer: "PHP" },
                            { name: "Python", value: "PYTHON", paramExplorer: "PYTHON" },
                            { name: "Ruby", value: "RUBY", paramExplorer: "RUBY" },
                        ],
                    },
                };
            },
            mounted() {
                const storedLanguage = sessionStorage.getItem("language");
                if (storedLanguage) {
                    this.selectedLanguage = JSON.parse(storedLanguage);
                } else {
                    sessionStorage.setItem(
                        "language",
                        JSON.stringify({ name: "Java", value: "JAVA", paramExplorer: "JAVA" }),
                    );
                    this.selectedLanguage = { name: "Java", value: "JAVA", paramExplorer: "JAVA" };
                }
                if (document.querySelector(`#${container.id} #tryitButton`)) {
                    this.canLinkToAPIExplorer = true;
                    this.getSnippets();
                }
            },
            methods: {
                async getSnippets() {
                    this.loading = true;
                    const snippetUrl = `${document.querySelector(`#${container.id} #snippetUrl`).value}?language=${this.selectedLanguage.paramExplorer}`;

                    const codeEl = `#${container.id} .${this.selectedLanguage.paramExplorer}`;
                    this.snippetUrl = snippetUrl;

                    try {
                        const response = await fetch(snippetUrl);
                        if (!response.ok) {
                            // noinspection ExceptionCaughtLocallyJS
                            throw new Error(response.status);
                        }

                        const jsonData = await response.json();
                        document.querySelector(codeEl).innerHTML = jsonData.sampleBody;
                        Prism.highlightElement(document.querySelector(codeEl));

                        if (jsonData.apiExplorerParameters) {
                            document.querySelector(`#${container.id} #tryitButton`).href =
                                `${document.querySelector(`#${container.id} #tryitUrl`).value}${jsonData.apiExplorerParameters}`;
                        } else {
                            document.querySelector(`#${container.id} #tryitButton`).style.display = "none";
                        }
                    } catch (error) {
                        console.error("There was an error!", error);
                    } finally {
                        this.loading = false;
                    }
                },
                setLanguage(langItem) {
                    Object.entries(codeComponents).forEach((codeInstance) => {
                        codeInstance[1].selectedLanguage = langItem;
                        if (codeInstance[1].snippetUrl) {
                            codeInstance[1].getSnippets();
                        }
                    });
                    sessionStorage.setItem("language", JSON.stringify(langItem));
                    if (document.querySelector(".language-nav")) {
                        setLanguageNav(langItem.value);
                    }
                },
                copy(activeCodeSnippet) {
                    const code = `code-${activeCodeSnippet.value}`;
                    const textA = this.$refs[activeCodeSnippet.value];
                    textA.value = unescapeHTML(this.$refs[code].innerHTML.replace(/<\/?[^>]+(>|$)/g, ""));
                    window.direct.selectText(this.$refs[code]);

                    navigator.clipboard.writeText(this.$refs[activeCodeSnippet.value].value).then(() => {
                        this.$refs.copy.setAttribute("data-copy-state", "copy-success");
                        setTimeout(() => {
                            textA.value = null;
                            this.$refs.copy.removeAttribute("data-copy-state");
                            window.getSelection().removeAllRanges();
                        }, 2000);
                    });
                },
            },
        });

        window.direct.setGlobalLanguage = setGlobalLanguage;

        function setGlobalLanguage(language) {
            Object.entries(codeComponents).forEach((codeInstance) => {
                codeInstance[1].setLanguage(language);
            });

            if (document.querySelector(".language-nav")) {
                setLanguageNav(language);
            }
        }

        if (document.querySelector(".language-nav")) {
            setLanguageNav();
        }
    });
});

function unescapeHTML(v) {
    return v.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
}

function setLanguageNav() {
    const selectedLanguage = JSON.parse(sessionStorage.getItem("language"));
    if (selectedLanguage) {
        document.querySelectorAll(".language-nav a").forEach((item) => {
            item.classList.remove("active");
            if (item.classList.contains(`language-nav-${selectedLanguage.value}`)) {
                item.classList.add("active");
            }
        });
    }
}

const OFFSET = 60;
const skipLinks = document.querySelectorAll(".skip-content");

skipLinks.forEach((skipLink) => {
    skipLink.addEventListener("click", (e) => {
        e.preventDefault();

        const targetId = skipLink.getAttribute("href").substring(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        target.focus({ preventScroll: true });

        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = target.getBoundingClientRect().top;
        const offsetPosition = elementRect - bodyRect - OFFSET;

        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    });
});
